// Phone Input Module
export function initializePhoneInput() {
  const phoneInput = document.getElementById('phone');
  if (!phoneInput || typeof window.intlTelInput === 'undefined') {
    return;
  }

  // Check if already initialized
  if (window.phoneIti) {
    return;
  }

  // Initialize intl-tel-input
  const iti = window.intlTelInput(phoneInput, {
    initialCountry: 'tr',
    preferredCountries: ['tr', 'de', 'fr', 'es', 'it', 'gb', 'us'],
    separateDialCode: true,
    autoPlaceholder: 'aggressive',
    formatOnDisplay: true,
    nationalMode: false,
    customPlaceholder: function (
      selectedCountryPlaceholder,
      selectedCountryData
    ) {
      return selectedCountryPlaceholder;
    },
    utilsScript:
      'https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js',
  });

  // Update hidden fields when country changes
  phoneInput.addEventListener('countrychange', function () {
    const countryData = iti.getSelectedCountryData();
    const countryField = document.getElementById('phone-country');
    if (countryField) {
      countryField.value = countryData.iso2;
    }
  });

  // Update full phone number before form submission
  phoneInput.addEventListener('blur', function () {
    if (iti.isValidNumber()) {
      const fullPhoneField = document.getElementById('phone-full');
      if (fullPhoneField) {
        fullPhoneField.value = iti.getNumber();
      }
    }
  });

  // Store reference for form submission
  window.phoneIti = iti;
}

// Initialize when intlTelInput is available
export function waitForPhoneInput() {
  if (typeof window.intlTelInput !== 'undefined') {
    initializePhoneInput();
  } else {
    // Wait for intlTelInput to load
    window.addEventListener('load', function () {
      if (typeof window.intlTelInput !== 'undefined') {
        initializePhoneInput();
      }
    });

    // Also try with a delay and CDN fallback
    setTimeout(() => {
      if (typeof window.intlTelInput !== 'undefined' && !window.phoneIti) {
        initializePhoneInput();
      } else if (!window.phoneIti) {
        loadIntlTelInputCDN();
      }
    }, 1000);
  }
}

// CDN Fallback loader
function loadIntlTelInputCDN() {
  return new Promise(resolve => {
    // Check if already loading
    if (document.querySelector('script[src*="intl-tel-input"]')) {
      resolve();
      return;
    }

    // Load CSS
    const css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href =
      'https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/css/intlTelInput.min.css';
    document.head.appendChild(css);

    // Load JS
    const script = document.createElement('script');
    script.src =
      'https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/intlTelInput.min.js';
    script.onload = () => {
      window.intlTelInput =
        window.intlTelInput || window.intlTelInputGlobals?.intlTelInput;

      if (typeof window.intlTelInput !== 'undefined') {
        initializePhoneInput();
      }
      resolve();
    };
    script.onerror = () => {
      resolve();
    };
    document.head.appendChild(script);
  });
}
